<template>
    <ScrimModal @close="cerrarNotas" :fondo="true">
        <template v-slot:body>
            <div class="d-flex justify-content-between mt-3">
                <div>
                    <span class="s-icono-base" style="background-color: #478ee4;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #fff"><path d="M2.165 19.551c.186.28.499.449.835.449h15c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 11h-1V8c0-1.103-.897-2-2-2h-6.655L8.789 4H4c-1.103 0-2 .897-2 2v13h.007a1 1 0 0 0 .158.551zM18 8v3H6c-.4 0-.762.238-.919.606L4 14.129V8h14z"></path></svg>
                    </span>
                    <span class="h5 color-negro delgado2 mt-2 ms-3">{{ $store.state.nameCourse }}</span>
                </div>
                <div>
                    <button class="btn btn-base2 btn-opaco" @click="cerrarNotas">
                        Cerrar notas
                    </button>
                </div>
            </div>
            <nav class="navbar navbar-expand-sm navbar-light bg-light mt-1"
                style="background-color: #fff !important; border-radius: 10px;padding: 0rem 0rem;box-shadow: none !important;">
                <div class="container-fluid">
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText"
                        aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarText">
                        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                            <li class="nav-item"
                                style=" font-size: 14px !important;font-weight: 600 !important;padding: 0.55rem 0rem;"
                                :class="{ 'activated': tab === 0 }">
                                <a class="nav-link" aria-current="page" style="color: #050505;" href="javascript:;"
                                    @click="tab = 0" :class="{ 'active': tab === 0 }">
                                    Primer trimestre</a>
                            </li>
                            <li class="nav-item"
                                style="margin-left: 10px; font-size: 14px !important;font-weight: 600 !important;padding: 0.55rem 0rem;"
                                :class="{ 'activated': tab === 1 }">
                                <a class="nav-link" href="javascript:;" style="color: #050505;" @click="tab = 1"
                                    :class="{ 'active': tab === 1 }">Segundo trimestre</a>
                            </li>
                            <li class="nav-item"
                                style="margin-left: 10px; font-size: 14px !important;font-weight: 600 !important;padding: 0.55rem 0rem;"
                                :class="{ 'activated': tab === 2 }">
                                <a class="nav-link" href="javascript:;" style="color: #050505;" @click="tab = 2"
                                    :class="{ 'active': tab === 2 }">Tercer trimestre</a>
                            </li>
                            <li v-if="$store.state.items?.curso?.num==6" class="nav-item"
                                style="margin-left: 10px; font-size: 14px !important;font-weight: 600 !important;padding: 0.55rem 0rem;"
                                :class="{ 'activated': tab === 3 }">
                                <a class="nav-link" href="javascript:;" style="color: #050505;" @click="tab = 3"
                                    :class="{ 'active': tab === 3 }">Evaluación</a>
                            </li>
                            <li class="nav-item"
                                style="margin-left: 10px; font-size: 14px !important;font-weight: 600 !important;padding: 0.55rem 0rem;"
                                :class="{ 'activated': tab === 5 }">
                                <a class="nav-link position-relative" href="javascript:;" style="color: #050505;" @click="tab = 5"
                                    :class="{ 'active': tab === 5 }">Reportes
                                    <span style="transform: translate(-50%,-30%)!important;"
                                        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                                        new
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <div class="ui-side-panel-content mt-2" style="margin-bottom: 5rem">
                <div v-if="isLoading" class="card-ed3" style="height: 50vh">
                    <Spinner />
                </div>
                <div v-else>
                    <Fechas v-if="!activo && tab != 5" />
                    <div v-else>
                        <PrimTrimestre v-if="tab == 0" :help="help" :idCursodeMatricula="idCursodeMatricula"
                            @refresh="initialSetup" :fechaActivo="fechaActivo" @reporte="save" :subnivel="subnivel" />
                        <SegTrimestre v-if="tab == 1" :help="help" :idCursodeMatricula="idCursodeMatricula"
                            @refresh="initialSetup" :fechaActivo="fechaActivo" @reporte="save" :subnivel="subnivel" />
                        <TercTrimestre v-if="tab == 2" :help="help" :idCursodeMatricula="idCursodeMatricula"
                            @refresh="initialSetup" :fechaActivo="fechaActivo" @reporte="save" :subnivel="subnivel" />
                        <section  v-if="tab == 3">
                            <Suspense>
                                <template #default>
                                    <ExamCuartos :help="help" :idCursodeMatricula="idCursodeMatricula"
                                   @refresh="initialSetup" :fechaActivo="fechaActivo" @reporte="save" :subnivel="subnivel" />
                                </template>
                                <template #fallback>
                                    <Spinner :isLoad="true" />
                                </template>
                            </Suspense>
                        </section>
                    </div>
                    <ReportNotes v-if="tab == 5" @reportes="saveReport" />
                    <section v-if="isReport">
                        <Suspense>
                            <template #default>
                                <FormA3 :arrarDta="arrarDta" :ops="ops" :isOptions="isOptions" @close="isReport = false" />
                            </template>
                            <template #fallback>
                                <Spinner :isLoad="true" />
                            </template>
                        </Suspense>
                    </section>
                </div>
            </div>
        </template>
    </ScrimModal>
</template>
<script setup>
import Spinner from '@/shared/Spinner.vue';
import ScrimModal from "@/shared/ScrimMenu.vue";
import Fechas from '@/shared/Fechas.vue';
import { defineAsyncComponent, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useNotas } from "@/hooks/useNotas"
import PrimTrimestre from "../components/basica/PrimTrimestre.vue"
import SegTrimestre from "../components/basica/SegTrimestre.vue"
import TercTrimestre from "../components/basica/TercTrimestre.vue"
import ReportNotes from "../components/ReportNotes.vue"

const emit = defineEmits(['closed', 'getData'])
const store = useStore()
const isOptions = ref('')
const isReport = ref(false)
const ops = ref({})
const arrarDta = ref([])
const { help2, help, isLoading, idUsuario, fechaActivo, activo, idCursodeMatricula, contador, 
    initialSetup, subnivel, tab } = useNotas()

const cerrarNotas = () => {
    emit('closed')
    if (contador.value > 1) emit('getData')
}

const saveReport = (num) => {
    const model = {
        quimestre: '',
        q1: true,
        q2: true
    }
    arrarDta.value = []
    arrarDta.value = help2.value
    if (num === 1) model.quimestre = 'PRIMER TRIMESTRE'
    if (num === 2) model.quimestre = 'SEGUNDO TRIMESTRE'
    if (num === 3) model.quimestre = 'TERCER TRIMESTRE'
    ops.value = model
    arrarDta.value = []
    arrarDta.value = help2.value
    if (num === 1 || num === 2 || num === 3) isOptions.value = '50'
    if (num === 5||num === 4) isOptions.value = '51'
    isReport.value = true
}
const save = async () => {
    const model = {
        quimestre: '',
        q1: true,
        q2: true
    }
    if (tab.value === 0) model.quimestre = 'PRIMER TRIMESTRE'
    if (tab.value === 1) model.quimestre = 'SEGUNDO TRIMESTRE'
    if (tab.value === 2) model.quimestre = 'TERCER TRIMESTRE'
    ops.value = model
    arrarDta.value = []
    arrarDta.value = help2.value
    if (tab.value === 0 || tab.value === 1 || tab.value === 2) isOptions.value = '50'
    if (tab.value === 5||tab.value === 3) isOptions.value = '51'
    isReport.value = true
}

const FormA3 = defineAsyncComponent(() =>
    import('../../reportes/components/FormA3.vue')
)
const ExamCuartos = defineAsyncComponent(() =>
    import('../components/basica/ExamCuartos.vue')
)
onMounted(() => {
    idUsuario.value = store.getters.user.id
    initialSetup()
})
</script>